import { useEffect, useMemo, useState } from 'react'
import { caseRef } from '../firebase'
import { isValidCaseRecord, warnInvalidCaseRecordOnce } from './shareCaseRecord'

export const useLiveVisibleCases = (baseCases = [], enabled = true) => {
  const [liveCasesByKey, setLiveCasesByKey] = useState({})

  const caseKeys = useMemo(
    () => baseCases.map((content) => content?.key).filter(Boolean),
    [baseCases]
  )
  const keySignature = caseKeys.join(',')

  useEffect(() => {
    if (!enabled || caseKeys.length <= 0) {
      setLiveCasesByKey({})
      return undefined
    }

    const cleanups = caseKeys.map((caseKey) => {
      const ref = caseRef.child(caseKey)
      const handleValue = (snapshot) => {
        const value = snapshot.val()
        if (!value) return
        if (!isValidCaseRecord(value)) {
          warnInvalidCaseRecordOnce(caseKey, value)
          return
        }

        setLiveCasesByKey((prev) => ({
          ...prev,
          [caseKey]: {
            ...value,
            key: caseKey,
          },
        }))
      }

      ref.on('value', handleValue)
      return () => ref.off('value', handleValue)
    })

    return () => {
      cleanups.forEach((cleanup) => cleanup())
      setLiveCasesByKey((prev) => {
        const next = { ...prev }
        caseKeys.forEach((caseKey) => {
          delete next[caseKey]
        })
        return next
      })
    }
    // caseKeys の実体差分は keySignature が代表する。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, keySignature])

  return useMemo(() => {
    if (caseKeys.length <= 0) return []

    return baseCases.map((content) => {
      const liveContent = liveCasesByKey[content.key]
      return liveContent ? liveContent : content
    })
  }, [baseCases, caseKeys.length, liveCasesByKey])
}
